export default __webpack_public_path__ + "static/media/22191.8460ae13.jpg";